var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeyboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "55px",
    height: "55px",
    viewBox: "0 0 72 72",
    enableBackground: "new 0 0 72 72",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.068,27.042H39.347c1.547-1.921,2.457-4.064,2.501-6.105c0.045-2.189-0.869-4.144-2.642-5.653 c-4.139-3.521-4.629-5.188-2.388-8.109c0.672-0.876,0.507-2.132-0.369-2.805c-0.875-0.671-2.13-0.508-2.805,0.369 c-5.136,6.694,0.137,11.181,2.969,13.592c0.851,0.723,1.255,1.548,1.234,2.522c-0.037,1.731-1.396,3.891-3.464,5.505 c-0.243,0.189-0.423,0.426-0.552,0.684H10.932C7.104,27.042,4,30.146,4,33.974v27.137c0,3.828,3.104,6.931,6.932,6.932h50.136 c3.828,0,6.932-3.104,6.932-6.932h0.001V33.974C68.001,30.146,64.896,27.042,61.068,27.042z M64.001,61.111 c0,1.619-1.313,2.932-2.933,2.932H10.932C9.313,64.043,8,62.73,8,61.111V33.974c0-1.619,1.313-2.932,2.932-2.932h50.136 c1.619,0,2.932,1.313,2.932,2.932h0.001V61.111z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.795,38.042h-1c-0.553,0-1,0.446-1,1s0.447,1,1,1h1c0.553,0,1-0.446,1-1S19.348,38.042,18.795,38.042z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.795,40.042h1c0.553,0,1-0.446,1-1s-0.447-1-1-1h-1c-0.553,0-1,0.446-1,1S24.242,40.042,24.795,40.042z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.795,40.042h1c0.553,0,1-0.446,1-1s-0.447-1-1-1h-1c-0.553,0-1,0.446-1,1S31.242,40.042,31.795,40.042z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.795,40.042h1c0.553,0,1-0.446,1-1s-0.447-1-1-1h-1c-0.553,0-1,0.446-1,1S37.242,40.042,37.795,40.042z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.795,40.042h1c0.553,0,1-0.446,1-1s-0.447-1-1-1h-1c-0.553,0-1,0.446-1,1S44.242,40.042,44.795,40.042z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.795,38.042h-1c-0.553,0-1,0.446-1,1s0.447,1,1,1h1c0.553,0,1-0.446,1-1S53.348,38.042,52.795,38.042z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.795,44.042h-1c-0.553,0-1,0.446-1,1s0.447,1,1,1h1c0.553,0,1-0.446,1-1S19.348,44.042,18.795,44.042z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.795,46.042h1c0.553,0,1-0.446,1-1s-0.447-1-1-1h-1c-0.553,0-1,0.446-1,1S24.242,46.042,24.795,46.042z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.795,46.042h1c0.553,0,1-0.446,1-1s-0.447-1-1-1h-1c-0.553,0-1,0.446-1,1S31.242,46.042,31.795,46.042z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.795,46.042h1c0.553,0,1-0.446,1-1s-0.447-1-1-1h-1c-0.553,0-1,0.446-1,1S37.242,46.042,37.795,46.042z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.795,46.042h1c0.553,0,1-0.446,1-1s-0.447-1-1-1h-1c-0.553,0-1,0.446-1,1S44.242,46.042,44.795,46.042z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.795,44.042h-1c-0.553,0-1,0.446-1,1s0.447,1,1,1h1c0.553,0,1-0.446,1-1S53.348,44.042,52.795,44.042z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.795,56.042h-1c-0.553,0-1,0.446-1,1s0.447,1,1,1h1c0.553,0,1-0.446,1-1S19.348,56.042,18.795,56.042z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.795,56.042h-22c-0.553,0-1,0.446-1,1s0.447,1,1,1h22c0.553,0,1-0.446,1-1S47.348,56.042,46.795,56.042z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.795,56.042h-1c-0.553,0-1,0.446-1,1s0.447,1,1,1h1c0.553,0,1-0.446,1-1S53.348,56.042,52.795,56.042z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.795,50.042h-1c-0.553,0-1,0.446-1,1s0.447,1,1,1h1c0.553,0,1-0.446,1-1S19.348,50.042,18.795,50.042z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.795,52.042h1c0.553,0,1-0.446,1-1s-0.447-1-1-1h-1c-0.553,0-1,0.446-1,1S24.242,52.042,24.795,52.042z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.795,52.042h1c0.553,0,1-0.446,1-1s-0.447-1-1-1h-1c-0.553,0-1,0.446-1,1S31.242,52.042,31.795,52.042z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.795,52.042h1c0.553,0,1-0.446,1-1s-0.447-1-1-1h-1c-0.553,0-1,0.446-1,1S37.242,52.042,37.795,52.042z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.795,52.042h1c0.553,0,1-0.446,1-1s-0.447-1-1-1h-1c-0.553,0-1,0.446-1,1S44.242,52.042,44.795,52.042z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.795,50.042h-1c-0.553,0-1,0.446-1,1s0.447,1,1,1h1c0.553,0,1-0.446,1-1S53.348,50.042,52.795,50.042z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboard);
export default __webpack_public_path__ + "static/media/keyboard.7226d633655bfcfa5e6adcbee9d4ed4c.svg";
export { ForwardRef as ReactComponent };